import { Requests } from "../common/request.common";
import { SettingsResponseTypes } from "../common/response.common";
import { get, post } from "./common";

export const settings = {
    obtainFirebase() {
        return get<SettingsResponseTypes.ObtainFirebase>("/settings/obtain/firebase");
    },
    updateFirebase(data: typeof Requests.Settings.UpdateFsa.Input) {
        return post<typeof data>("/settings/update/firebase", data);
    },
    activate(data: typeof Requests.Settings.Activate.Input) {
        return post<typeof data, SettingsResponseTypes.Activate>("/settings/activate", data);
    },
};
